import React from "react";
import { Button } from "antd";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import AppContext from "../../context/app/context";
import PageHeader from "../../components/general/layout/page-header";
import styles from "./style.module.scss";
import RefreshBtn from "../../components/general/table-components/actions/refresh-btn";
import SectionCompanyTable from "../../components/companies/section-company-table";
import TrademarkContextProvider from "../../context/trademark/provider";

const Companies: React.FC = () => {
  const { t } = useTranslation();
  const { direction } = useContext(AppContext);
  const [isSortingEnabled, setIsSortingEnabled] = useState(false);
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [tableLoading, setTableLoading] = useState(false);
  const location = useLocation();

  return (
    <div dir={direction} className={styles.container}>
      <PageHeader
        title={t("companies")}
        subTitle={t("arrangement_companies_in_sections")}
        extra={[
          <RefreshBtn
            key={0}
            loading={tableLoading}
            onClick={() => setRefreshTrigger(!refreshTrigger)}
          >
            {t("refresh")}
          </RefreshBtn>,
          <Button
            key={1}
            type="primary"
            onClick={() => {
              setIsSortingEnabled(!isSortingEnabled);
            }}
          >
            {isSortingEnabled ? t("disable_sorting") : t("enable_sorting")}
          </Button>,
        ]}
      />
      <SectionCompanyTable
        isSortingEnabled={isSortingEnabled}
        sectionId={location.state?.sectionId}
        freeDelivery={location.state?.freeDelivery}
        discountOffer={location.state?.discountOffer}
        refreshTrigger={refreshTrigger}
        onLoadingChange={setTableLoading}
      />
    </div>
  );
};

const SectionCompaniesPage = () => {
  return (
    <TrademarkContextProvider>
      <Companies />
    </TrademarkContextProvider>
  );
};

export default SectionCompaniesPage;